module.exports = __webpack_public_path__ + "static/img/10.3c19284.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/10.png
// module id = Q6Ne
// module chunks = 5